import React from 'react';
import MicroZoneGraphs from "../../components/Graph/MicroZoneGraphs";
import Stack from "@mui/material/Stack";
import MicroZoneAutocomplete from "../../components/inputs/MicroZonesAutocomplete/MicroZoneAutocomplete";


const AvalanchesAnalytics = ({selectedMicroZone, setSelectedMicroZone}) => {
    return <Stack gap={2}>
        <MicroZoneAutocomplete selectedStation={selectedMicroZone}
                             setSelectedStation={setSelectedMicroZone}
                             waitFocus={false}
                             initializeFirst={true}
                             fullWidth
                             sx={{alignSelf: "flex-start"}}/>
        <MicroZoneGraphs microZoneId={selectedMicroZone?.id} microZoneCode={selectedMicroZone?.code}/>
    </Stack>
}

export default AvalanchesAnalytics;